import React from "react"
import TextField from "components/ReactHookForm/TextField"
import { Control, FieldValues } from "react-hook-form"
import { Stack, Text, Link as ChakraLink } from "@chakra-ui/react"
import InfoSegment from "../InfoSegment"

type Props<T extends FieldValues> = {
  control: Control<T, object>
  email: string
  onNotMe: () => void
}

const ConfirmAccountScreen = <T extends FieldValues, >({
  control,
  email,
  onNotMe,
}: Props<T>) => (
  <>
    <InfoSegment />
    <Stack>
      <Stack spacing={4} mb={4}>
        <Text>This invite will activate a Lead Retrieval license on the account:</Text>
        <Text fontWeight="semibold">
          {email}
        </Text>
        <Text>
          If this is you, enter your exhibitor name below and activate. Once activated, you
          can login to the Lead Retrieval App to access the event.
        </Text>
      </Stack>
      <TextField
        control={control}
        name="name"
        vertical
        variant="outline"
        label="Exhibitor Name"
        placeholder="ACME Corp"
        helperText="In most cases, this should be the name of your company or team. You can change this later."
        showAsterisk
      />
      <ChakraLink color="blue.500" fontSize="sm" onClick={onNotMe}>This isn&apos;t me</ChakraLink>
    </Stack>
  </>
  )

export default ConfirmAccountScreen
